import React from "react";
import { ReactComponent as BurgerLineSvg } from "../assets/svg/burger-line.svg";
import "../css/burger-line-button.css";

const BurgerLineButton = ({ onClick, isActive, className }) => {
  return (
    <button
      onClick={onClick}
      className={`burger-icon burger-icon-lines${isActive ? " active" : ""} ${
        className ? className : ""
      }`}
    >
      <span></span>
      <span></span>
      <span></span>
    </button>
  );
};

export default BurgerLineButton;
